import gql from 'graphql-tag';

export const SearchIncidentIssueDocument = gql`
  query SearchIncidentIssueDocument($input: IncidentIssueDocumentConnectionInput) {
    searchIncidentIssueDocument {
      incidentIssueDocumentConnection(input: $input) {
        totalCount
        edges {
          node {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            issueId
            filename
            fileLocation
            contentType
            fileSize
            md5
          }
          cursor
        }
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
      }
    }
  }
`;
